import React from "react";
import { Link } from "react-router-dom";
import { blogs } from "../../blogs";
import "./Blogs.css";

const Blogs = () => {
  return (
    <div className="blogs-page">
      {/* Header Section */}
      <div className="blogs-header">
        <h1 className="blogs-title">Our Blogs</h1>
        <p className="blogs-subtitle">
          Insights, guides, and updates from the Charamy team
        </p>
      </div>

      {/* Blog Grid */}
      <div className="blogs-grid">
        {blogs.map((blog) => (
          <Link 
            to={`/blogs/${blog.slug}`} 
            key={blog.id}
            className="blog-card-link"
          >
            <div className="blog-card">
              {blog.image && (
                <div className="blog-image-wrapper">
                  <img 
                    src={blog.image} 
                    alt={blog.title}
                    className="blog-image"
                    loading="lazy"
                  />
                </div>
              )}
              
              <div className="blog-content">
                <div className="blog-date">
                  {blog.date || "April 2026"}
                </div>
                
                <h2 className="blog-card-title">
                  {blog.title.length > 60 ? blog.title.substring(0, 60) + "..." : blog.title}
                </h2>
                
                <p className="blog-excerpt">
                  {blog.excerpt.length > 120 ? blog.excerpt.substring(0, 120) + "..." : blog.excerpt}
                </p>
                
                <div className="read-more">
                  Read Article
                  <span className="read-more-arrow">→</span>
                </div>
              </div>
            </div>
          </Link>
        ))}
      </div>

      {/* Footer Section */}
      <div className="blogs-footer">
        {/* Add any footer content here */}
      </div>
    </div>
  );
};

export default Blogs;